"use client";

import { HeaderOrdersLink } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderOrdersLink";
import { useLanguage } from "@faire/retailer-visitor-shared/hooks/retailer/useLanguage";
import { useRetailerStatus } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerStatus";
import { useUserStoreV2 } from "@faire/retailer-visitor-shared/hooks/user/useUserStoreV2";
import {
  useAssignSettingOrdersInGlobalNav,
  useSettingOrdersInGlobalNav,
} from "@faire/retailer-visitor-shared/settings/useSettingOrdersInGlobalNav";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ILanguageSelectorProps } from "@faire/web--source/ui/LanguageSelector/common";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import React, { Suspense, useEffect } from "react";

import { HeaderNotificationsDropdown } from "../../HeaderNotifications/HeaderNotificationsDropdown";
import { HeaderLine } from "../../styled";
import { HeaderAccountDropdown } from "../HeaderAccountDropdown";
import { LazyHeaderLanguageSelector } from "../HeaderLanguageSelector/LazyHeaderLanguageSelector";

export const LoggedInLoginSection: React.FC = () => {
  const { showLanguageSelector } = useLanguage();
  const { browserLevelLanguage, browserLevelLocaleKey } = useUserStoreV2();

  const availableLanguageSelectorLocales =
    getGlobalProperty<ILocaleKey[]>("availableLanguageSelectorLocales") ?? [];

  const assignOrdersInGlobalNav = useAssignSettingOrdersInGlobalNav();
  const { isDesktopAndAbove } = useViewport();
  const { hasPlacedFirstOrder } = useRetailerStatus();

  useEffect(() => {
    if (isDesktopAndAbove && hasPlacedFirstOrder) {
      assignOrdersInGlobalNav();
    }
  }, [assignOrdersInGlobalNav, isDesktopAndAbove, hasPlacedFirstOrder]);

  const shouldShowOrdersInGlobalNav =
    useSettingOrdersInGlobalNav() && isDesktopAndAbove && hasPlacedFirstOrder;

  return (
    <>
      {showLanguageSelector ? (
        <LanguageSelectorSection
          eventKey="logged-in-top"
          browserLanguage={browserLevelLanguage as Language}
          browserLocale={browserLevelLocaleKey}
          availableLocales={availableLanguageSelectorLocales}
          assignLocalizedUrl
        />
      ) : null}
      {shouldShowOrdersInGlobalNav ? <HeaderOrdersLink /> : null}
      <HeaderNotificationsDropdown />
      <HeaderAccountDropdown />
    </>
  );
};

const LanguageSelectorSection = (props: ILanguageSelectorProps) => {
  return (
    <>
      <Suspense fallback={null}>
        <LazyHeaderLanguageSelector {...props} />
      </Suspense>
      <HeaderLine />
    </>
  );
};
